import { callAPI, HTTPMethod } from "./API";
import { SearchByRfc, DeleteTenantCfdisRequest } from "../model/Tenant";
import { Providers } from "../model/Provider";
import { ImpersonalizeUserRequest, ValidatePasswordRequest, SafeToNotifyRequest } from '../model/User';
import { Session } from "../model/Session";
import { RevalidationSAT, CfdiAllowedToDeleteResponse, CfdiBackwardPendingPaymentRequest } from "./Support";
import { ApiLog, ApiLogs, ApiLogsListParams } from "./ApiLog";

export async function listProvidersByRfc(request: SearchByRfc, tenantId: string): Promise<Providers> {
    return await callAPI(`/support/tenants/${tenantId}/providers`, {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function deletePayableData(request: DeleteTenantCfdisRequest): Promise<void> {
    return await callAPI("/support/delete-payable-data", {
        method: HTTPMethod.DELETE,
        body: request
    });
}

export async function validatePassword(request: ValidatePasswordRequest): Promise<void> {
    return await callAPI("/support/validate-password", {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function impersonalizeUser(request: ImpersonalizeUserRequest): Promise<Session> {
    return await callAPI("/support/impersonalize-user", {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function revalidateSAT(): Promise<RevalidationSAT> {
    return await callAPI("/support/revalidate-sat", {
        method: HTTPMethod.PUT,
    });
}

export async function getCfdiAllowedToDelete(uuid: string): Promise<CfdiAllowedToDeleteResponse> {
    return await callAPI(`/support/cfdi-allowed-to-delete/${uuid}`, {
        method: HTTPMethod.GET,
    });
}

export async function backwardErpToPendingPayment(request: CfdiBackwardPendingPaymentRequest): Promise<void> {
    return await callAPI("/support/backward-to-pending-payment", {
        method: HTTPMethod.PUT,
        body: request
    });
}

export async function safeToNotify( request: SafeToNotifyRequest ): Promise<void> {
    return await callAPI(`/support/user-safe-to-notify`, {
        method: HTTPMethod.PUT,
        body:request
    });
}

export async function getApiLogs(pageSize: number, offset: number, params: ApiLogsListParams): Promise<ApiLogs> {
    let query = {
        id: params.id ? params.id : "",
        date: params.date ? params.date.replace(" - ", ",") : "",
        tenant: params.tenant ? params.tenant : "",
        method: params.method ? params.method : "",
        url: params.url ? params.url : "",
        responseCode: params.response_code ? params.response_code : "",
        ipAddress: params.ip_address ? params.ip_address : "",
        pageSize: pageSize.toString(),
        offset: offset.toString()
    } as Record<string, string>;


    return await callAPI(`/support/api-logs`, {
        method: HTTPMethod.GET,
        query: query,
    });
}

export async function getApiLog(apiLogId: string) : Promise<ApiLog> {
    return await callAPI(`/support/api-logs/${apiLogId}`, {
        method: HTTPMethod.GET
    });
}

export async function deleteSeDocuments(request: DeleteTenantCfdisRequest): Promise<void> {
    return await callAPI("/support/delete-se-documents", {
        method: HTTPMethod.DELETE,
        body: request
    });
}